import CommonResourcesEn from "./CommonResources.En";

export default {
  ...CommonResourcesEn,
  title: "<b>Register</b> and benefit from goodie cashback",
  codeDescription: "Invitation code: ",
  formTitle: "Sign up",
  formTitleModal: "<b>Register</b> in goodie",
  formButton: "I sign up via {ProviderName}",
  socialButtonsTitle: "or sign up how you like",
  changeScreenButtonText: "You have an account already?",
  changeScreenButtonLink: "Log in",
};
